import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import { getDefaultBodyType, lazyOpenCompose, lazyTrySaveAndCloseCompose, ComposeTarget, } from 'owa-mail-compose-store';
import { onNewMessage } from 'owa-mail-module-orchestrator';
import { action } from 'satcheljs/lib/legacy';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { getGuid } from 'owa-guid';
// Load options now to retrieve emoji skin tone options before expression pane is opened
import 'owa-outlook-service-options';
export default action('newMessage', datapoints.MailComposeNew)(function newMessage(actionSource, groupId, toEmailAddressWrappers, subject, body) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var openTarget, bodyType, toRecipients, logTraceId, newMessageDatapoint, composeInitProps;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    openTarget = isTabViewEnabled()
                        ? ComposeTarget.SecondaryTab
                        : ComposeTarget.PrimaryReadingPane;
                    if (!(openTarget === ComposeTarget.PrimaryReadingPane)) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyTrySaveAndCloseCompose.importAndExecute(null /*viewState*/)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    bodyType = getDefaultBodyType();
                    toRecipients = [];
                    if (toEmailAddressWrappers) {
                        toRecipients.push.apply(toRecipients, toEmailAddressWrappers);
                    }
                    logTraceId = getGuid();
                    newMessageDatapoint = returnTopExecutingActionDatapoint();
                    // Datapoint is not present for unit tests
                    if (newMessageDatapoint) {
                        newMessageDatapoint.addCustomData({
                            composeTraceId: logTraceId,
                            actionSource: actionSource,
                        });
                    }
                    composeInitProps = {
                        operation: 0 /* New */,
                        bodyType: bodyType,
                        to: toRecipients,
                        preferAsyncSend: true,
                        subject: subject,
                        newContent: body,
                        logTraceId: logTraceId,
                    };
                    return [4 /*yield*/, lazyOpenCompose.importAndExecute(composeInitProps, openTarget, groupId)];
                case 3:
                    _a.sent();
                    onNewMessage(openTarget === ComposeTarget.SecondaryTab);
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=newMessage.js.map